import React, { useState } from "react";
import { FaRegTrashAlt, FaSpinner, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { BsExclamationLg } from "react-icons/bs";
import { deleteFuel, fetchFuels } from "../../../redux/slices/fuelSlice";

export default function ModalDeleteLaundrySub({
  id,
  fuelType,
  fuelPrice,
  fuelCity,
  fuelState,
  fuelCountry,
}) {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.category.isLoading);

  const handleDelete = async () => {
    try {
      const res = await dispatch(deleteFuel(id));
      await dispatch(fetchFuels());
      toast.success(res.payload.message);
    } catch (error) {
      console.error(error);
    }
    setShowModal(false);
  };

  return (
    <>
      <button type="button" onClick={() => setShowModal(true)}>
        <FaRegTrashAlt className="text-base text-[#667085] focus:text-[#00AAFF]" />
      </button>
      {showModal ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-5xl">
              <div className="border-0 rounded-lg p-6 shadow-lg relative flex flex-col bg-white outline-none focus:outline-none">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center"
                >
                  <FaTimes className="text-gray-300 text-xl" />
                  <span className="sr-only">Close modal</span>
                </button>
                <div className=" text-center mb-4">
                  <h1 className="text-2xl text-gray-800 text-center font-medium">
                    Delete Fuel & Gas
                  </h1>
                  <p>Do you want to Delete this Fuel & Gas ?</p>
                </div>
                <div className="flex justify-center items-center m-2">
                  <BsExclamationLg className="text-gray-500 text-3xl font-bold" />
                </div>
                <div className="flex items-center px-8 py-4 gap-6">
                  <div className="flex flex-row gap-6 ">
                    <div className="flex flex-col gap-4">
                      <div className="flex flex-row gap-2">
                        <h1 className="text-[14px] text-left text-gray-400 ">
                          Type :
                        </h1>
                        <div className="">
                          <p className=" text-base font-bold">{fuelType}</p>
                        </div>
                      </div>

                      <div className="flex flex-row gap-2">
                        <h1 className="text-[14px] text-left text-gray-400 ">
                          Price :
                        </h1>
                        <div className="">
                          <p className=" text-base font-bold">
                            <span className="mr-1">&#8358;</span>
                            {fuelPrice}
                          </p>
                        </div>
                      </div>

                      <div className="flex flex-row gap-2">
                        <h1 className="text-[14px] text-gray-400 ">
                          Name of City :
                        </h1>
                        <div className="">
                          <p className="text-base font-bold">{fuelCity}</p>
                        </div>
                      </div>
                    </div>

                    <div className="flex flex-col gap-4">
                      <div className="flex flex-row gap-2">
                        <h1 className="text-[14px] text-gray-400 ">
                          Name of State :
                        </h1>
                        <div className="">
                          <p className="text-base font-bold">{fuelState}</p>
                        </div>
                      </div>

                      <div className="flex flex-row gap-2">
                        <h1 className="text-[14px] text-gray-400 ">
                          Name of Country :
                        </h1>
                        <div className="">
                          <p className="text-base font-bold">{fuelCountry}</p>
                        </div>
                      </div>

                      <div className="flex mt-2 gap-4 justify-center">
                        <button
                          onClick={() => setShowModal(false)}
                          className="text-sm text-gray-500 font-semibold bg-gray-100 py-2 px-4 rounded-md"
                        >
                          Cancel
                        </button>
                        <button
                          className="flex gap-1 rounded-md items-center bg-red-600 text-white py-2 px-4"
                          disabled={loading}
                          onClick={handleDelete}
                        >
                          {loading ? (
                            <>
                              <FaSpinner className="animate-spin" />
                              <p className="text-sm font-semibold whitespace-nowrap">
                                Deleting ...
                              </p>
                            </>
                          ) : (
                            <>
                              <FaTimes className="w-4 h-4" />
                              <p className="text-sm font-semibold whitespace-nowrap">
                                Delete Fuel & Gas
                              </p>
                            </>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
